// https://vuex.vuejs.org/en/state.html
// TODO  obtener token try - catch, JSON parse error
export default {
  drawer: false,
  titleAppBar: '',
  token: { "access_token": "H6Ogwk8XfCwP38kiM3dbcSJF2svE6P", "expires_in": 3153600000, "token_type": "Bearer", "scope": "read write", "refresh_token": "SUdcwfCs06dMbdWerJnyZtZG2ikrKp" },
}
